import { render } from "./DFileInput.vue?vue&type=template&id=5905b99e"
import script from "./DFileInput.vue?vue&type=script&lang=js"
export * from "./DFileInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__